export default __webpack_public_path__ + "static/media/experience.48ccb206.svg";